export default theme => ({
    notificationSlider: {},
    notificationsDiv: {
        top: 0,
        right: 0,
        flex: '1 0 auto',
        height: '100%',
        width: '80%',
        display: 'flex',
        zIndex: '1200',
        outline: 'none',
        position: 'fixed',
        overflowY: 'auto',
        flexDirection: 'column',
        backgroundColor: '#212121',
        [theme.breakpoints.up('sm')]: {
            width: '400px',
        }
    },
    notifSliderHeader: {
        minHeight: '60px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 21,
        boxShadow: '0px 1px 5px -1px rgba(0, 0, 0, 0.82)',
        color: '#fafafa',
        '& h6': {
            fontSize: 15,
            fontWeight: 'bold',
            margin: 0,
        }
    },
    notifList: {
        padding: '20px 5px 5px 5px',
        '& .notifItem': {
            width: 'initial',
            minHeight: 66,
            padding: '13px 3px',
            borderRadius: 3,
            marginBottom: 10,
            boxShadow: '0px 1px 1px -1px #fafafac7',
            alignItems: 'flex-start'
        },
        '& .notifItem .icon': {
            marginTop: -8,
        },
        '& .notifItem svg': {
            fontSize: 20,
            color: '#fafafa',
        },
        '& .notifTitle': {
            padding: '0 3px',
        },
        '& .notifTitle span': {
            fontSize: '1rem',
            color: '#fafafa',
        },
        '& .notifItem:hover': {
            boxShadow: '0px 0px 3px -1px #fafafac7',
        },
        '& .infoContainer': {
            display: 'flex',
            flexDirection: 'column',
        },
        '& .notifSubtitle': {
            padding: '0px 3px',
            '& > span': {
                color: '#7f7f7f',
                fontSize: '.95em',
            },
        },
        '& .newIndicator': {
            display: 'inline-block',
            width: 10,
            height: 10,
            position: 'absolute',
            right: 5,
            top: 5,
            backgroundColor: '#74bd43',
            borderRadius: '50%',
        },
        [theme.breakpoints.up('sm')]: {
            padding: '30px 20px 5px 20px',
            '& .notifItem': {
                boxShadow: '0px 0px 3px -1px #fafafac7',
            },
            '& .notifItem svg': {
                fontSize: 25,
            },
            '& .notifTitle span': {
                fontSize: '1rem',
            },
            '& .notifItem .icon': {
                marginTop: -5,
            },
        }
        ,
    },
    transparentAvatar: {
        backgroundColor: 'transparent',
        width:
            40,
        height:
            40,
        display:
            'block',
    }
    ,
    notificationsIcon: {
        width: 30,
        height:
            30,
    }
    ,
})
